import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // CRITICAL: se estamos a voltar do OAuth Google, saltar o /me — o AuthCallback trata da sessão.
    if (window.location.hash && window.location.hash.includes("session_id=")) {
      setLoading(false);
      return;
    }
    let active = true;
    api.get("/auth/me")
      .then((r) => { if (active) setUser(r.data); })
      .catch(() => { if (active) setUser(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const value = useMemo(() => ({
    user,
    loading,
    login: async (email, password) => {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data.user);
      return data.user;
    },
    refresh: async () => {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    },
    logout: async () => {
      try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
      setUser(null);
    },
  }), [user, loading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
